import { render, staticRenderFns } from "./primary-filter.vue?vue&type=template&id=679dc89c&"
import script from "./primary-filter.vue?vue&type=script&lang=ts&"
export * from "./primary-filter.vue?vue&type=script&lang=ts&"
import style0 from "./primary-filter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports